/*  ===============节点列表=====================*/

export interface iAreaBackup {
  id: number;
  name: string;
  city: string;
  region_id: number;
  region_name: string;
  is_public: boolean;
  policy_id: number;
  policy_name: string;
  policy_type: number;
}

/*  ===============策略=====================*/

/* 备机数量 */
export interface iMM {
  min: number;
  max: number;
}

/* 开始结束时间 */
export interface iBackupPeriods {
  start: number;
  end: number;
}

export interface iConfig {
  low: iMM;
  high: iMM;
  free: iMM;
}
//普通时段
export interface iCommon {
  backup_num: iConfig;
}
//特殊时段，特殊时段为数组，有顺序，分队对应特殊时段
export interface iCustom {
  backup_days: string[]; //日期 周一到周末
  backup_periods: iBackupPeriods[]; //备机时间段
  backup_num: iConfig; //备机数量
}

export interface iBackupTactics {
  name: string;
  type: eType;
  common: iCommon;
  custom: iCustom;
}
export enum eDays {
  /**
   * 周一
   */

  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
  SUNDAY = 'Sunday',
}
export enum eType {
  /**
   * 默认策略 后天设置,不能删除
   */
  DEFAULT = 1,
  /**
   *-自定义策略
   */

  CUSTOM = 2,
}

export enum eRulesDialogContentStatus {
  /**查看详情 */
  INFO = 'info',
  /**编辑状态 */
  EDIT = 'edit',
  /**新建 */
  CREATE = 'create',
  /**更改策略 */
  UPDATATACTICS = 'update_tactics',
}
